import React, { useState } from 'react';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import img1Improvement from '../../assets/img1Improvement.png';
import img2Improvement from '../../assets/img2Improvement.png';
import img3Improvement from '../../assets/img3Improvement.png';
import img4Improvement from '../../assets/img4Improvement.png';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import styles from "./styles.module.css";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Importando useTranslation
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
// import { apiBase, apiKey, appName } from '../../config';


function CarbonImprovement() {
    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        telefone: "",
        mensagem: "",
    });
    const [submiting, setSubmiting] = useState(false);
    const apiKey = process.env.REACT_APP_API_KEY;
    const apiBase = process.env.REACT_APP_API_BASE_URL;
    const appName = process.env.REACT_APP_NAME;

    const { t } = useTranslation(); // Usando useTranslation para acessar as traduções
    const navigate = useNavigate(); // Para navegação programática
    // Função para redirecionar ao clicar no botão
    const handleNavigate = (path) => {
        navigate(path);
    };

    // Atualiza os dados do formulário
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleGoFirstPage = () => {
        navigate('/');
    }

    // Gerencia o envio do formulário
    const handleSubmit = async () => {
        setSubmiting(true);


        const { nome, email, telefone, mensagem } = formData;

        if (!nome || !email || !telefone || !mensagem) {

            alert("Por favor, preencha todos os campos obrigatórios!");
            // setTimeout(() => {
            //     console.log("Delayed for 1 second.");
            // }, "3000");

            return;
        }

        try {
            await fetch(`${apiBase}co2message/${apiKey}`, {
                method: 'POST',
                body: JSON.stringify({
                    nome,
                    email,
                    subject: "Contactar",
                    country: "Portugal",
                    telefone,
                    mensagem,
                    languageCode: "pt-PT",
                    creationSource: appName
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
        } catch (err) {

        }

        // Reseta o formulário após o envio
        setFormData({
            nome: "",
            email: "",
            telefone: "",
            mensagem: "",
        });
        setSubmiting(false);

    };


    return (
        <div className='form-background'>
            <div className='div-agroinsider-logo'>
                <img onClick={() => handleNavigate('/')} style={{ marginBottom: "0px", cursor: "pointer" }} src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
            </div>
            <div style={{ padding: "20px 0px", maxWidth: "1000px" }} className='farm-profile-description'>
                <span className='farm-profile-title'>{t('CarbonImprovement.title')}</span>
                <span className='farm-profile-title' style={{ fontSize: "18px", margin: "10px 20px", }}>{t('CarbonImprovement.description')}</span>
            </div>
            <div className={styles.CarbonImprovementContainer}>
                <div className={styles.CarbonImprovementCards}>
                    <div className={styles.CarbonImprovementCard}>
                        <div className={styles.CarbonImprovementCardText}>
                            <span className={styles.CarbonImprovementCardTextTitle}>
                                {t("CarbonImprovement.card1Title")}
                            </span>
                            <span className={styles.CarbonImprovementCardTextContent}>
                                {t("CarbonImprovement.card1Description")}
                            </span>
                        </div>
                        <div className={styles.CarbonImprovementCardImage} style={{ backgroundImage: `url(${img1Improvement})` }}>
                        </div>
                    </div>
                    <div className={styles.CarbonImprovementCard}>
                        <div className={styles.CarbonImprovementCardText}>
                            <span className={styles.CarbonImprovementCardTextTitle}>
                                {t("CarbonImprovement.card2Title")}
                            </span>
                            <span className={styles.CarbonImprovementCardTextContent}>
                                {t("CarbonImprovement.card2Description")}
                            </span>
                        </div>
                        <div className={styles.CarbonImprovementCardImage} style={{ backgroundImage: `url(${img2Improvement})` }}>
                        </div>
                    </div>
                    <div className={styles.CarbonImprovementCard}>
                        <div className={styles.CarbonImprovementCardText}>
                            <span className={styles.CarbonImprovementCardTextTitle}>
                                {t("CarbonImprovement.card3Title")}
                            </span>
                            <span className={styles.CarbonImprovementCardTextContent}>
                                {t("CarbonImprovement.card3Description")}
                            </span>
                        </div>
                        <div className={styles.CarbonImprovementCardImage} style={{ backgroundImage: `url(${img3Improvement})` }}>
                        </div>
                    </div>
                    <div className={styles.CarbonImprovementCard}>
                        <div className={styles.CarbonImprovementCardText}>
                            <span className={styles.CarbonImprovementCardTextTitle}>
                                {t("CarbonImprovement.card4Title")}
                            </span>
                            <span className={styles.CarbonImprovementCardTextContent}>
                                {t("CarbonImprovement.card4Description")}
                            </span>
                        </div>
                        <div className={styles.CarbonImprovementCardImage} style={{ backgroundImage: `url(${img4Improvement})` }}>
                        </div>
                    </div>
                </div>
                <div className='farm-profile-description' style={{ margin: "40px auto" }}>
                    <span className='farm-profile-title'>{t('CarbonImprovement.HelpTitle')}</span>
                    <span className='farm-profile-description-text'>{t('CarbonImprovement.HelpDescription')}</span>
                </div>
                <div className="form-profile-form">
                    <div className="form-group">
                        <div className="form-group-specialist">
                            <input
                                type="text"
                                name="nome"
                                placeholder="Nome"
                                value={formData.nome}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group-specialist">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group-specialist">
                            <input
                                type="tel"
                                name="telefone"
                                placeholder="Número de Telefone"
                                value={formData.telefone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group-specialist">
                            <textarea
                                name="mensagem"
                                placeholder="Mensagem"
                                value={formData.mensagem}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className="form-group-buttons" style={{ flexDirection: "column", alignItems: "center" }}>
                    <button className="form-next-button" onClick={() => handleSubmit()} disabled={submiting}>{t('ConsultSpecialist.submit')}</button>

                    <button onClick={() => handleGoFirstPage()} className='initial-page-button'>
                        <span className='arrow-icon'>←</span>
                        <span>{t('initial_page')}</span>
                    </button>
                </div>
                <LanguageSwitcher />
                <div className='div-logo-footer-color'>
                    <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
                </div>
            </div>
        </div>
    );
}

export default CarbonImprovement;
